var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#191a23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41253 5.91421C8.03745 6.28929 7.52875 6.5 6.99831 6.5C6.46788 6.5 5.95917 6.28929 5.5841 5.91421C5.20903 5.53914 4.99831 5.03043 4.99831 4.5C4.99831 3.96957 5.20903 3.46086 5.5841 3.08579C5.95917 2.71071 6.46788 2.5 6.99831 2.5C7.52875 2.5 8.03745 2.71071 8.41253 3.08579C8.7876 3.46086 8.99831 3.96957 8.99831 4.5C8.99831 5.03043 8.7876 5.53914 8.41253 5.91421Z",
    stroke: "#191a23",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35182 8.99342C10.0353 9.4919 10.5428 10.1945 10.8013 11H3.19531C3.45378 10.1945 3.96133 9.4919 4.6448 8.99342C5.32828 8.49494 6.15237 8.22634 6.99831 8.22634C7.84425 8.22634 8.66835 8.49494 9.35182 8.99342Z",
    stroke: "#191a23",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.322111ba3837ef3665d9ecfcee864145.svg";
export { ForwardRef as ReactComponent };